import React, { FunctionComponent } from 'react';

import { rgba } from 'polished';
import styled, { useTheme } from 'styled-components';

import Typography from '@components/basics/typography';
import ArrowIcon from '@components/basics/icons/arrow';
import AnimateNumber, {
  AnimateNumberFomat,
} from '@components/animations/animate-number';

interface PercentageProps {
  className?: string;
  value: number;
  valueFormat?: AnimateNumberFomat;
  noAnimation?: boolean;
  noBackground?: boolean;
  isRed?: boolean;
}

const Percentage: FunctionComponent<PercentageProps> = ({
  className,
  value,
  valueFormat,
  noAnimation,
  noBackground,
  isRed,
}) => {
  const theme = useTheme();

  const getPercentageColor = (value: number) => {
    if (value === 0) {
      return theme.colors.tertiary;
    } else if (value < 0 || isRed) {
      return theme.colors.accent;
    } else if (value > 0) {
      return theme.colors.green;
    } else {
      return theme.colors.primary;
    }
  };

  const getGreyColor = () => {
    return theme.colors.secondary;
  };

  return (
    <div
      className={className || ''}
      style={{
        backgroundColor: !noBackground
          ? value === 0
            ? getGreyColor()
            : rgba(getPercentageColor(value), 0.2)
          : 'transparent',
      }}
    >
      <Typography
        className={noBackground ? 'value normal' : 'value'}
        style={{
          color: getPercentageColor(value),
          display: 'flex',
        }}
      >
        {noBackground && (value > 0 ? '+' : '')}
        {value ? (
          <AnimateNumber
            from={0}
            to={value}
            format={valueFormat}
            noAnimation={noAnimation}
          />
        ): ("0%")}
      </Typography>
      {!noBackground &&
        (value !== 0 ? (
          <ArrowIcon
            className="icon"
            up={value < 0}
            size={12}
            customColor={getPercentageColor(value)}
          />
        ) : (
          <Typography
            className="icon"
            style={{ color: getPercentageColor(value) }}
          >
            -
          </Typography>
        ))}
    </div>
  );
};

export default styled(Percentage)`
  padding: ${(props) => (props.noBackground ? 0 : '4px 8px')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;

  .value {
    font-size: ${({ theme }) => theme.typography.small};
    line-height: ${({ theme }) => theme.typography.small};
    font-weight: 700;

    &.normal {
      font-size: ${({ theme }) => theme.typography.span};
      line-height: ${({ theme }) => theme.typography.span};
      font-weight: 400;
    }
  }

  .icon {
    margin-left: 4px;
  }
`;
